"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _starRating = require("star-rating");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _style = _interopRequireDefault(require("../../src/styles/style.scss"));

require("../../src/styles/external.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var MOBILE_MAX_WIDTH = 767;

var Review = function Review(props) {
  var recommendeeId = props.recommendeeId,
      profileName = props.profileName,
      date = props.date,
      review = props.review,
      rating = props.rating,
      likes = props.likes,
      profileImage = props.profileImage,
      specialtyImage = props.specialtyImage,
      specialist = props.specialist,
      comment = props.comment,
      className = props.className,
      titleStyle = props.titleStyle,
      reviewContentStyle = props.reviewContentStyle,
      disableLikeButton = props.disableLikeButton,
      loggedIn = props.loggedIn,
      buttonClicked = props.buttonClicked,
      onClick = props.onClick,
      onReportReview = props.onReportReview;
  return _react.default.createElement("div", {
    className: "".concat(_style.default.reviews, " ").concat(className),
    style: props.style
  }, _react.default.createElement("div", {
    className: _style.default.reviewHeader
  }, _react.default.createElement("h3", {
    className: "".concat(_style.default.reviewAuthor, " ").concat(titleStyle)
  }, "BY A VERIFIED PATIENT"), profileName && profileName.trim() && _react.default.createElement("div", {
    className: _style.default.recommendeeContainer
  }, "Reviewing ", _react.default.createElement("span", {
    className: _style.default.profileName
  }, profileName.trim())), date && _react.default.createElement("div", {
    className: _style.default.reviewDate
  }, date)), _react.default.createElement("div", {
    className: _style.default.stars
  }, _react.default.createElement(_starRating.StarRating, {
    averageRating: rating
  }), props.isRatingTextValueShown && _react.default.createElement("p", {
    className: _style.default.starsTextValue
  }, "(", rating, ")")), _react.default.createElement("div", {
    className: "".concat(_style.default.reviewContent, " ").concat(reviewContentStyle)
  }, review), !disableLikeButton && _react.default.createElement("div", {
    className: loggedIn ? _style.default.likeButtonContainerLoggedIn : _style.default.likeButtonContainerLoggedOut
  }, _react.default.createElement("span", {
    "data-tip": "You must be logged in to like a comment",
    "data-for": "react-tooltip"
  }, _react.default.createElement("button", {
    disabled: loggedIn ? '' : 'disabled',
    onClick: onClick,
    className: buttonClicked && loggedIn ? "".concat(_style.default.likeButtonClicked, " btn") : _style.default.likeButton
  }, _react.default.createElement("span", null, _react.default.createElement("i", {
    className: 'ion-thumbsup'
  }), likes)), loggedIn ? null : _react.default.createElement(_reactTooltip.default, {
    id: "react-tooltip",
    place: typeof window !== 'undefined' && window.innerWidth > MOBILE_MAX_WIDTH ? 'top' : 'right'
  })), onReportReview && _react.default.createElement("span", null, _react.default.createElement("button", {
    className: "btn ".concat(_style.default['flag']),
    onClick: onReportReview
  }, _react.default.createElement("span", null, _react.default.createElement("i", {
    className: "ion-ios-flag ".concat(_style.default['flag-icon'])
  }))))), comment ? _react.default.createElement("div", {
    className: _style.default.reviewComment
  }, _react.default.createElement("div", {
    className: _style.default.imageContainer
  }, _react.default.createElement("img", {
    className: _style.default.profile_image,
    src: profileImage ? profileImage : specialtyImage
  })), _react.default.createElement("div", {
    className: _style.default.commentContainer
  }, _react.default.createElement("h3", null, specialist), comment)) : null);
};

Review.propTypes = {
  profileName: _propTypes.default.string,
  date: _propTypes.default.string,
  review: _propTypes.default.string,
  likes: _propTypes.default.number,
  rating: _propTypes.default.number,
  profileImage: _propTypes.default.string,
  specialist: _propTypes.default.string,
  comment: _propTypes.default.string,
  className: _propTypes.default.string,
  titleStyle: _propTypes.default.string,
  reviewContentStyle: _propTypes.default.string,
  disableLikeButton: _propTypes.default.bool,
  loggedIn: _propTypes.default.bool,
  buttonClicked: _propTypes.default.bool,
  onClick: _propTypes.default.string,
  onReportReview: _propTypes.default.string,
  specialtyImage: _propTypes.default.string,
  isRatingTextValueShown: _propTypes.default.bool
};
Review.displayName = 'Review';
Review.defaultProps = {
  disableLikeButton: false,
  isRatingTextValueShown: false
};

var _default = (0, _reactIntl.injectIntl)(Review);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/review/lib/components/review.js
// module id = 2192
// module chunks = 0